import React, { createContext } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

const ScreenResolutionContext = createContext();

const ScreenResolutionProvider = ({ children }) => {
    const isXs = useMediaQuery('(max-width:599px)');
    const isSm = useMediaQuery('(min-width:600px) and (max-width:959px)');
    const isMd = useMediaQuery('(min-width:960px) and (max-width:1279px)');
    const isMdSmall = useMediaQuery('(min-width:960px) and (max-width:1140px)');
    const isMdLarge = useMediaQuery('(min-width:1141px) and (max-width:1279px)');
    const isLg = useMediaQuery('(min-width:1280px) and (max-width:1919px)');
    const isXl = useMediaQuery('(min-width:1920px) and (max-width:2659px)')
    const isLandscape = useMediaQuery('(orientation: landscape) and (max-width: 950px)');
    const screenSizeCategory = isXs ? 'xs'
        : isSm ? 'sm'
            : isMdSmall ? 'md-small'
                : isMdLarge ? 'md-large'
                    : isMd ? 'md'
                    : isLg ? 'lg'
                        : isXl ? 'xl'
                            : 'xxl';
    return (
        <ScreenResolutionContext.Provider value={{ screenSizeCategory, isLandscape }}>
            {children}
        </ScreenResolutionContext.Provider>
    );
};

export { ScreenResolutionProvider, ScreenResolutionContext };